import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "./Reveal";

export const EditorialBreak = ({ src, altKey, testId, credit, fullBleed = false }) => {
  const { t } = useLanguage();
  const caption = (credit && t[credit]) || t.photoCredit;
  const altText = t[altKey] || altKey;

  const img = (
    <img
      data-testid={testId}
      src={src}
      alt={altText}
      className={`w-full object-cover ${fullBleed ? "aspect-[16/9] md:aspect-[21/8]" : "aspect-[16/9] md:aspect-[21/9]"}`}
    />
  );

  if (fullBleed) {
    return (
      <section data-testid={`${testId}-section`} className="py-8 md:py-14">
        <Reveal>
          <figure>
            <div className="overflow-hidden bg-muted">{img}</div>
            <div className="mx-auto max-w-[1600px] px-6 md:px-12">
              <figcaption className="mt-4 text-[11px] tracking-[0.12em] text-foreground/45">
                {caption}
              </figcaption>
            </div>
          </figure>
        </Reveal>
      </section>
    );
  }

  return (
    <section data-testid={`${testId}-section`} className="py-8 md:py-14">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <Reveal>
          <figure>
            <div className="overflow-hidden bg-muted">{img}</div>
            <figcaption className="mt-4 text-[11px] tracking-[0.12em] text-foreground/45">
              {caption}
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </section>
  );
};
